// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageSizeSelect_wrapper__30E7C","text":"PageSizeSelect_text__1Duz9","select":"PageSizeSelect_select__3xoFs"};